<template>
  <div>
    <el-dialog
      title="报警信息"
      :visible.sync="dlgState"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div
        style="display: flex;height: 80px;margin-bottom: 10px;margin-left: 30px;"
      >
        <!-- <img style="height: 74px;" src="../../../assets/imgs/jksl-bg.png" alt=""> -->
        <el-image
          style="height: 74px;"
          :src="infoData.imgUrl"
          :preview-src-list="imgUrlList"
          alt="暂无图片"
        ></el-image>
        <div class="ml10 mt10">
          <div
            style="width: 300px;font-size: 16px;font-weight: bolder;color: #E86452;"
          >
            <span>{{ infoData.event }}</span>
            <span style="float: right;">
              <el-tag type="danger">{{infoData.alarmLevelKey}}</el-tag>
              <!-- <dict-tag
                style="font-size: 16px;color: #E86452;background-color: #fff;border: none;"
             
                :value="infoData.alarmLevelValue"
              /> -->
            </span>
          </div>
          <div style="width: 200px;margin-top: 10px;font-size: 14px;">
            <div style="width: 300px;">
              <span class="mr10">时间: {{ infoData.createTime }}</span>
              <span>人员: {{ infoData.personcount }}人</span>
            </div>
            <div style="width: 400px">
              地点:
              {{
                infoData.buildingName +
                  "-" +
                  infoData.unitName +
                  "-" +
                  infoData.liftName
              }}
            </div>
          </div>
        </div>
      </div>
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-width="100px"
        v-loading="formLoading"
      >
        <el-form-item label="报警原因" prop="alarmReasonValue">
          <el-select
            :disabled="!isInfo"
            v-model="formData.alarmReasonValue"
            filterable
            clearable
            placeholder="请选择报警原因"
          >
            <el-option
              v-for="item in alarmReasonList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理方式" prop="handleWayValue">
          <el-select
            :disabled="!isInfo"
            v-model="formData.handleWayValue"
            filterable
            clearable
            placeholder="请选择处理方式"
          >
            <el-option
              v-for="item in processTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理时间" prop="handleTime">
          <el-date-picker
            :disabled="!isInfo"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="formData.handleTime"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            :disabled="!isInfo"
            v-model="formData.remark"
            placeholder="请输入备注"
            type="textarea"
            resize="none"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="submitForm"
          type="primary"
          :disabled="formLoading"
          v-if="isInfo"
          icon="el-icon-check"
          >确 定</el-button
        >
        <el-button @click="closeDlg('fanhui')" icon="el-icon-back">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 接口
import { alarmInfo,alarmHandle } from "@/api/leftMan";
import * as utils from "@/utils";
import dayjs from "dayjs";
import {
  arrId2Name, // 根据id 获取name
  getDataDictOther // 数据字典
} from "@/utils";
let formDataEmpty = {
  id: "",
  alarmReasonKey: "", //	报警原因key
  alarmReasonValue: "", //	报警原因value
  handleWayKey: "", //	处理方式key
  handleWayValue: "", //	处理方式value
  handleTime: "", //	处理时间
  handleUserId: "", //	处理人ID
  handleUserName: "",
  remark: ""
};
export default {
  props: {
    dlgState0: {
      type: Boolean,
      default: false
    },
    dlgQuery: {
      type: Object,
      default: {}
    },
    dlgType: {
      type: String,
      default: ""
    }
  },
  watch: {
    dlgState0(val) {
      console.log(val, "val");
      this.dlgState = val;
    },
    dlgState(val) {
      this.$nextTick(() => {
        this.$refs["formRef"].clearValidate();
      });
      this.formData=JSON.parse(JSON.stringify(formDataEmpty))
      if (val) {
        this.getInfo();
      } else {
        this.$emit("closeDlg");
      }
    }
  },
  data() {
    return {
      dlgState: false,
      formLoading: false,
      isInfo: true,
      userInfo: JSON.parse(window.localStorage.userInfo),
      formData: JSON.parse(JSON.stringify(formDataEmpty)), // 初始化数据
      formRules: {
        alarmReasonValue: [
          { required: true, message: "请选择报警原因", trigger: "change" }
        ],
        handleWayValue: [
          { required: true, message: "请选择处理方式", trigger: "change" }
        ],
        handleTime: [
          { required: true, message: "请选择处理时间", trigger: "change" }
        ]
      },
      imgUrlList: [],
      infoData: {},
      processTypeList: [],
      alarmReasonList: []
    };
  },
  created() {
    getDataDictOther(this, "processType", "processTypeList"); // 处理方式
    getDataDictOther(this, "alarmReason", "alarmReasonList"); // 报警原因
  },
  methods: {
    getInfo() {
      alarmInfo(this.dlgQuery.id).then(res1 => {
        let res = res1.data;
        if (res.code == 200) {
          // if (!utils.isNull(res.data.imgUrl)) {
          //   res.data.imgUrl = res.data.imgUrl
          //     .slice(0, 0)
          //     .concat("http://", res.data.imgUrl);
          // }
          this.imgUrlList = [res.data.imgUrl];
          res.data.createTime = res.data.createTime
          this.infoData = res.data;
          if (this.dlgType == "info") {
            this.formData.handleTime = res.data.handleTime
            this.formData.handleWayValue = res.data.handleWayValue;
            this.formData.handleWayKey = res.data.handleWayKey;
            this.formData.alarmReasonValue = res.data.alarmReasonValue;
            this.formData.alarmReasonKey = res.data.alarmReasonKey;
            this.formData.remark = res.data.remark;
            this.isInfo = false;
            console.log(this.formData,'this.formData');
          } else {
            this.isInfo = true;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    submitForm() {
      this.$refs["formRef"].validate(valid => {
        if (valid) {
          let sendObj = JSON.parse(JSON.stringify(this.formData));
          sendObj.id=this.dlgQuery.id
          sendObj.handleUserId = this.userInfo["id"];
          sendObj.handleUserName = this.userInfo["label"];
          sendObj.handleWayKey= arrId2Name(this.processTypeList, sendObj.handleWayValue);
          sendObj.alarmReasonKey= arrId2Name(this.alarmReasonList, sendObj.alarmReasonValue);
          this.formLoading= true
          alarmHandle(sendObj).then(res1 => {
            let res=res1.data
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "操作成功"
              });
             
              this.closeDlg('chuli');
            } else {
              this.$message({
                type: "warning",
                message: res.msg
              });
            }
            this.formLoading= false
          });
        }
      })
    },
    closeDlg(type) {
      this.$emit("closeDlg",type);
    }
  }
};
</script>
